export function findUniqueItemsIn(findIn, checkWith, comparator) {
  return findIn.filter(function (firstItem) {
    return checkWith.findIndex(function (secondItem) {
      return comparator ? comparator(firstItem, secondItem) : firstItem === secondItem;
    }) === -1;
  });
}